import React, { Component } from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../UniformComponents/Modal'
import Select from '../form/Select'
import DataTable from '../DataTable'
import Checkbox from '../form/Checkbox'
import Button from '../../UniformComponents/Button'
import { Store } from '../Modals/DownloadModal/store'
import Downloading from '../Modals/DownloadModal/downloading'
import Typography from '../../UniformComponents/Typography'

@observer
class ExportModal extends Component {
    @observable filters = {
        hidden: [],
        quantitative: [],
        qualitative: [],
        prepop: [],
        imported: [],
        questionLevel: [],
    }

    delimiterOptions = [
        { value: 'comma', label: i18n.t('report_delimiter_comma') },
        { value: 'semicolon', label: i18n.t('report_delimiter_semicolon') },
        { value: 'tab', label: i18n.t('report_delimiter_tab') },
    ]

    exportOptions = [
        {
            label: i18n.t('exportModal.aggregated'),
            options: [
                { value: 'xlsx', label: 'Excel' },
                { value: 'pdf', label: 'PDF' },
            ],
        },
        {
            label: i18n.t('exportModal.raw'),
            options: [
                { value: 'csv', label: 'CSV' },
                { value: '3s', label: 'Triple S' },
            ],
        },
        {
            label: i18n.t('general.other'),
            options: [
                { value: 'ppt', label: 'PowerPoint' },
            ],
        },
    ]

    constructor(props) {
        super(props)
        const { reportStore } = props
        const { questionMap } = reportStore
        this.downloadStore = new Store('report', reportStore.appStore, reportStore)
        this.state = {
            exportType: undefined,
            includeQuestions: Array.from(questionMap.keys()),
            delimiter: 'comma',
            includeMetadata: false,
            exportNumericValues: false,
            downloading: false,
            includeOtherSpecify: false,
            visibleFilter: '',
        }
    }

    componentDidMount() {
        const { reportStore } = this.props
        reportStore.exportInit()
    }

    handleDownload = () => {
        const {
            exportType, delimiter, exportNumericValues, includeMetadata, includeOtherSpecify,
        } = this.state
        this.downloadStore.downloadType = exportType
        this.downloadStore.downloadOptions.delimiter = delimiter
        this.downloadStore.downloadOptions.includeColumnMetadata = includeMetadata
        this.downloadStore.downloadOptions.numericExport = exportNumericValues
        this.downloadStore.downloadOptions.openEnded = includeOtherSpecify
        this.setState({ downloading: true })
    }

    toggleFilterVisible = (filter) => {
        const { visibleFilter } = this.state
        if (visibleFilter === filter) {
            this.setState({ visibleFilter: '' })
        } else {
            this.setState({ visibleFilter: filter })
        }
    }

    updateFilters = (col, e) => {
        if (e.value) {
            this.filters[col].push(e.name)
        } else {
            this.filters[col] = this.filters[col].filter((filter) => filter !== e.name)
        }
        this.filterTable()
    }

    filterTable = () => {
        const { reportStore } = this.props
        const { filters } = this

        reportStore.filteredQuestions = reportStore.questions.filter((q) => {
            const hasFilters = Object.values(filters).some((arr) => arr.length > 0)
            if (!hasFilters) return true

            if (filters.hidden.length && !filters.hidden.includes(q.hidden)) return false
            if (filters.prepop.length && !filters.prepop.includes(q.hasPrepopulatedData)) return false
            if (filters.quantitative.length && !filters.quantitative.includes(q.quantitative)) return false
            if (filters.qualitative.length && !filters.qualitative.includes(q.qualitative)) return false
            if (filters.questionLevel.length && !filters.questionLevel.includes(q.questionLevel)) return false

            return true
        })
    }

    toggleSelectAllVisible = (e) => {
        const { includeQuestions } = this.state
        const { reportStore } = this.props
        const filteredQuestionIds = reportStore.filteredQuestions.map((q) => q.id)

        if (e.value) {
            this.setState({ includeQuestions: Array.from(new Set([...includeQuestions, ...filteredQuestionIds])) })
        } else {
            this.setState({ includeQuestions: includeQuestions.filter((q) => !filteredQuestionIds.includes(q)) })
        }
    }

    columns = () => {
        const { reportStore } = this.props
        const { includeQuestions, visibleFilter } = this.state
        const { filteredQuestions } = reportStore
        const filteredQuestionIds = filteredQuestions.map((q) => q.id)
        const allVisibleIncluded = filteredQuestionIds.every((q) => includeQuestions.includes(q))
        return [
            {
                name: (<Checkbox
                    checked={allVisibleIncluded}
                    onBlur={(e) => this.toggleSelectAllVisible(e)}
                    stopPropagation
                />),
                dataTransform: (_, question) => (
                    <Checkbox
                        checked={includeQuestions.includes(question.id)}
                        onBlur={({ value }) => {
                            this.setState({
                                includeQuestions: value
                                    ? [...includeQuestions, question.id]
                                    : includeQuestions.filter((id) => id !== question.id),
                            })
                        }}
                        stopPropagation
                    />
                ),
                key: 'included',
            },
            {
                name: i18n.t('exportModal.questionTitle'),
                key: 'questionTitle',
            },
            {
                name: i18n.t('exportModal.questionDescription'),
                key: 'questionDescription',
            },
            {
                name: (
                    <div className="exportColumnContainer">
                        <div>{i18n.t('exportModal.questionLevel')}</div>

                        <i
                            className="fal fa-bars-filter"
                            onClick={(e) => {
                                this.toggleFilterVisible('questionLevel')
                                e.stopPropagation()
                            }}
                        />

                        {visibleFilter === 'questionLevel'
                            ? (
                                <div className="exportFilterContainer" onClick={(e) => e.stopPropagation()}>
                                    <div className="exportFilterOptions">
                                        <Checkbox
                                            name="Explori"
                                            checked={this.filters.questionLevel.includes('Explori')}
                                            onBlur={(e) => {
                                                this.updateFilters('questionLevel', e)
                                            }}
                                            label="Explori"
                                        />
                                        <Checkbox
                                            name="Company"
                                            checked={this.filters.questionLevel.includes('Company')}
                                            onBlur={(e) => {
                                                this.updateFilters('questionLevel', e)
                                            }}
                                            label="Company"
                                        />
                                        <Checkbox
                                            name="Survey"
                                            checked={this.filters.questionLevel.includes('Survey')}
                                            onBlur={(e) => {
                                                this.updateFilters('questionLevel', e)
                                            }}
                                            label="Survey"
                                        />
                                    </div>
                                </div>
                            ) : null}
                    </div>
                ),
                key: 'questionLevel',
            },
            {
                name: (
                    <div className="exportColumnContainer">
                        <div>{i18n.t('exportModal.quantitative')}</div>

                        <i
                            className="fal fa-bars-filter"
                            onClick={(e) => {
                                this.toggleFilterVisible('quantitative')
                                e.stopPropagation()
                            }}
                        />

                        {visibleFilter === 'quantitative'
                            ? (
                                <div className="exportFilterContainer" onClick={(e) => e.stopPropagation()}>
                                    <div className="exportFilterOptions">
                                        <Checkbox
                                            name="Yes"
                                            checked={this.filters.quantitative.includes('Yes')}
                                            onBlur={(e) => {
                                                this.updateFilters('quantitative', e)
                                            }}
                                            label={i18n.t('gen_yes')}
                                        />
                                        <Checkbox
                                            name="No"
                                            checked={this.filters.quantitative.includes('No')}
                                            onBlur={(e) => {
                                                this.updateFilters('quantitative', e)
                                            }}
                                            label={i18n.t('gen_no')}
                                        />
                                    </div>
                                </div>
                            ) : null}
                    </div>
                ),
                key: 'quantitative',
            },
            {
                name: (
                    <div className="exportColumnContainer">
                        <div>{i18n.t('exportModal.openEnd')}</div>

                        <i
                            className="fal fa-bars-filter"
                            onClick={(e) => {
                                this.toggleFilterVisible('qualitative')
                                e.stopPropagation()
                            }}
                        />

                        {visibleFilter === 'qualitative'
                            ? (
                                <div className="exportFilterContainer" onClick={(e) => e.stopPropagation()}>
                                    <div className="exportFilterOptions">
                                        <Checkbox
                                            name="Yes"
                                            checked={this.filters.qualitative.includes('Yes')}
                                            onBlur={(e) => {
                                                this.updateFilters('qualitative', e)
                                            }}
                                            label={i18n.t('gen_yes')}
                                        />
                                        <Checkbox
                                            name="No"
                                            checked={this.filters.qualitative.includes('No')}
                                            onBlur={(e) => {
                                                this.updateFilters('qualitative', e)
                                            }}
                                            label={i18n.t('gen_no')}
                                        />
                                    </div>
                                </div>
                            ) : null}
                    </div>
                ),
                key: 'qualitative',
            },
            {
                name: (
                    <div className="exportColumnContainer">
                        <div>{i18n.t('exportModal.imported')}</div>

                        <i
                            className="fal fa-bars-filter"
                            onClick={(e) => {
                                this.toggleFilterVisible('prepop')
                                e.stopPropagation()
                            }}
                        />

                        {visibleFilter === 'prepop'
                            ? (
                                <div className="exportFilterContainer" onClick={(e) => e.stopPropagation()}>
                                    <div className="exportFilterOptions">
                                        <Checkbox
                                            name="Yes"
                                            checked={this.filters.prepop.includes('Yes')}
                                            onBlur={(e) => {
                                                this.updateFilters('prepop', e)
                                            }}
                                            label={i18n.t('gen_yes')}
                                        />
                                        <Checkbox
                                            name="No"
                                            checked={this.filters.prepop.includes('No')}
                                            onBlur={(e) => {
                                                this.updateFilters('prepop', e)
                                            }}
                                            label={i18n.t('gen_no')}
                                        />
                                    </div>
                                </div>
                            ) : null}
                    </div>
                ),
                key: 'hasPrepopulatedData',
            },
            {
                name: (
                    <div className="exportColumnContainer">
                        <div>{i18n.t('exportModal.hidden')}</div>

                        <i
                            className="fal fa-bars-filter"
                            onClick={(e) => {
                                this.toggleFilterVisible('hidden')
                                e.stopPropagation()
                            }}
                        />

                        {visibleFilter === 'hidden'
                            ? (
                                <div className="exportFilterContainer" onClick={(e) => e.stopPropagation()}>
                                    <div className="exportFilterOptions">
                                        <Checkbox
                                            name="Yes"
                                            checked={this.filters.hidden.includes('Yes')}
                                            onBlur={(e) => {
                                                this.updateFilters('hidden', e)
                                            }}
                                            label={i18n.t('gen_yes')}

                                        />
                                        <Checkbox
                                            name="No"
                                            checked={this.filters.hidden.includes('No')}
                                            onBlur={(e) => this.updateFilters('hidden', e)}
                                            label={i18n.t('gen_no')}
                                        />
                                    </div>
                                </div>
                            ) : null}
                    </div>
                ),
                key: 'hidden',
            },
        ]
    }

    render() {
        const { reportStore } = this.props
        const {
            showExportModal, toggleShowExportModal, filteredQuestions, questions, appStore,
        } = reportStore
        const {
            exportType,
            delimiter,
            includeMetadata,
            exportNumericValues,
            downloading,
            includeQuestions,
            includeOtherSpecify,
        } = this.state
        return (
            <Modal
                show={showExportModal}
                onClose={toggleShowExportModal}
                cssClass="advancedExportModal"
            >
                {downloading
                    ? (
                        <Downloading
                            store={this.downloadStore}
                            includeQuestions={includeQuestions}
                            onClose={toggleShowExportModal}
                        />
                    ) : (
                        <div>
                            <h3 style={{ textAlign: 'center' }}>{i18n.t('exportModal.title')}</h3>
                            <div className="exportType">
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <div className="exportStep green">
                                        <b>1</b>
                                    </div>
                                    <Typography type="b">{i18n.t('exportModal.step1')}</Typography>
                                </div>
                                <Select
                                    name="exportType"
                                    label={`${i18n.t('exportModal.exportFormat')}:`}
                                    options={this.exportOptions}
                                    onBlur={({ value }) => this.setState({ exportType: value })}
                                    indentation
                                    style={{ width: '200px' }}
                                />

                                <hr />

                                {exportType === 'csv'
                                    ? (
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <div className="exportStep yellow">
                                                    <b>1.2</b>
                                                </div>
                                                <Typography type="b">{i18n.t('exportModal.step1.2')}</Typography>
                                            </div>
                                            <div style={{ display: 'flex', gap: '16px', width: '600px', marginTop: '16px' }}>
                                                <Select
                                                    style={{ width: '200px' }}
                                                    name="delimiter"
                                                    label={`${i18n.t('sch_upload_delimiter')}:`}
                                                    options={this.delimiterOptions}
                                                    onBlur={({ value }) => this.setState({ delimiter: value })}
                                                    value={this.delimiterOptions.find(({ value }) => value === delimiter)}
                                                />
                                                {(appStore.isReseller() || appStore.isExploriAdmin()) && (
                                                    <Checkbox
                                                        label={i18n.t('exportModal.includeMetadata')}
                                                        checked={includeMetadata}
                                                        onBlur={() => this.setState({ includeMetadata: !includeMetadata })}
                                                    />
                                                )}
                                                <Checkbox
                                                    label={i18n.t('exportModal.exportNumericValues')}
                                                    checked={exportNumericValues}
                                                    onBlur={() => this.setState(
                                                        { exportNumericValues: !exportNumericValues },
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    )
                                    : null}
                                {exportType === 'pdf'
                                    ? (
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <div className="exportStep yellow">
                                                    <b>1.2</b>
                                                </div>
                                                <Typography type="b">{i18n.t('exportModal.step1.2')}</Typography>
                                            </div>

                                            <div style={{ display: 'flex', gap: '16px', width: '600px', marginTop: '16px' }}>
                                                <Checkbox
                                                    label={i18n.t('exportModal.includeOther')}
                                                    checked={includeOtherSpecify}
                                                    onBlur={() => this.setState(
                                                        { includeOtherSpecify: !includeOtherSpecify },
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    )
                                    : null}
                            </div>

                            {['pdf', 'csv'].includes(exportType) && (
                                <>
                                    <hr />

                                    <br />
                                </>
                            )}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div className="exportStep purple">
                                    <b>2</b>
                                </div>
                                <Typography type="b">{i18n.t('exportModal.step2')}</Typography>
                            </div>

                            <div>
                                <Typography type="tiny">{i18n.t('exportModal.step2.description')}</Typography>

                                {Object.values(this.filters).some((arr) => arr.length > 0) && (
                                    <>
                                        <br />

                                        <Typography type="tiny">
                                            {i18n.t(
                                                'exportModal.questionsHidden',
                                                { 1: questions.length - filteredQuestions.length },
                                            )}
                                        </Typography>
                                    </>
                                )}
                            </div>

                            <br />

                            <div>
                                <DataTable
                                    inMemory
                                    dataSet={filteredQuestions}
                                    columns={this.columns()}
                                    recordCount={filteredQuestions.length}
                                    key="questionTable"
                                />
                            </div>
                            <div className="footerControls">
                                <Button
                                    label={i18n.t('cancel')}
                                    cssClass="tertiary regular"
                                    onClick={toggleShowExportModal}
                                />
                                <Button
                                    label={i18n.t('submit')}
                                    cssClass="primary regular"
                                    onClick={this.handleDownload}
                                    disabled={!exportType}
                                />
                            </div>
                        </div>
                    )}
            </Modal>
        )
    }
}

export default ExportModal
